import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Hidden, Paper } from "@material-ui/core";

import SimpleDialogDemo from "../../LayoutContainers/SimpleDialog";
//import LoginForm from "../Login/LoginForm";
import EventRegistryPublicForm from "./EventRegistryPublicForm";
import {
  configuracionEvento,
  paymentsConfigFunc,
  detalleEvento,
  eventSubEventsRegistry,
} from "../../../../data-store/actions/events-actions";
import { registryConfiguration, } from "../../../../data-store/actions/registry-actions";
import RegistryConfirmationPublic from "./RegistryConfirmation/RegistryConfirmationPublic";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 500,
    backgroundColor: theme.palette.background.paper,
    margin: "0px",
  },
  paper: {
    padding: "0px",
    backgroundColor: "#283747",
  },
  color: {
    padding: "0px",
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function EventRegistryPublic(props) {
  const {
    eventIdDashport,
    title,
    textBottom,
    name,
    eventLogo,
    image,
    imageMobile,
    renderType,
    titlesColors
  } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation("inscripcion");

  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();
  const registry = query.get("registry");
  const event = query.get("event");
  const secure3d = query.get("secure3d");
  const download = query.get("download");

  //const athleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const eventDetail = useSelector((state) => state.events.eventDetail);
  const eventSubEventsRegistryData = useSelector(
    (state) => state.events.eventSubEventsRegistry
  );
  const registryConfigurationData = useSelector(
    (state) => state.registry.registryConfiguration
  );
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [eventPast, setEventPast] = useState(false);
  // 1) Este se encarga de hacer el fetch


  useEffect(() => {
    if (eventIdDashport) {
      dispatch(detalleEvento(eventIdDashport));
      dispatch(eventSubEventsRegistry(eventIdDashport));
      dispatch(registryConfiguration(eventIdDashport));
      dispatch(configuracionEvento(eventIdDashport));
      dispatch(paymentsConfigFunc());
    }
  }, [dispatch, eventIdDashport]);

  // 2) Este se encarga de actualizar `eventPast` cuando `eventDetail` cambia
  useEffect(() => {
    if (eventDetail) {
      setEventPast(verificarFecha(eventDetail.fechaEvento));
    }
  }, [eventDetail]);
  // 3) Este se encarga del query param
  useEffect(() => {
    if (registry && eventIdDashport === event) {
      setShowConfirmation(true);
    }
  }, [registry, eventIdDashport, event]);

  function verificarFecha(fechaLimite) {
    const fechaActual = new Date(); // hoy
    const fechaComparar = new Date(fechaLimite); // por ejemplo "2025-04-10"

    // Normalizar ambas fechas al inicio del día (sin horas)
    fechaActual.setHours(0, 0, 0, 0);
    fechaComparar.setHours(0, 0, 0, 0);

    const diferenciaDias = (fechaActual - fechaComparar) / (1000 * 60 * 60 * 24);

    if (diferenciaDias >= 2) {
      // Condición si la fecha actual es mayor por al menos 1 día
      console.log("La fecha actual " + fechaActual + " es al menos un día después que la fecha límite");
      // Aplica aquí tu lógica personalizada
      return true;
    } else {
      console.log("La fecha actual " + fechaComparar + fechaActual + " aún no supera la fecha límite por un día");
      return false;
    }
  }

  function formatearFecha(fecha) {
    const [anio, mes, dia] = fecha.split("-");

    const diaFormateado = dia.padStart(2, '0');
    const mesFormateado = mes.padStart(2, '0');

    return `${diaFormateado}-${mesFormateado}-${anio}`;
  }  // Ejemplo de uso:



  if (
    eventSubEventsRegistryData === undefined ||
    Object.values(eventSubEventsRegistryData).length === 0 ||
    registryConfigurationData === undefined
  ) {
    return <div></div>;
  }

  function openEditMode(result) {
    console.log("Open edit mode");
  }
  function openModal() {
    console.log("Open registry");
    setOpen(true);
  }
  function renderDistanceConfigResumen(data) {
    data = Object.values(data).sort((a, b) => a.order - b.order);
    let view = [];
    for (var i in data) {
      if (!data[i].hide) {
        const monedaCodigo = registryConfigurationData.configuracion.moneda
          ? Object.values(
            registryConfigurationData.configuracion.moneda
          ).filter((a) => a.tipo === "base")[0].codigo
          : "MXN";
        view.push(
          <Grid item xs={12}>
            <Typography
              color="secondary"
              gutterBottom
              variant={"h4"}
              component="h2"
            >
              {data[i].descripcionModalidad}
            </Typography>
            <Typography
              color="primary"
              gutterBottom
              variant={"subtitle1"}
              component="h2"
            >
              {t("modalidadesCategorias.precio", {
                monto: data[i].configModalidad.precio.preventa_1.precio_1,
                moneda: monedaCodigo,
              })}
            </Typography>
          </Grid>
        );
      }
    }
    return view;
  }
  function renderDistanceConfig(data) {
    data = Object.values(data).sort((a, b) => a.order - b.order);
    let view = [];
    for (var i in data) {
      if (!data[i].hide) {
        const monedaCodigo = registryConfigurationData.configuracion.moneda
          ? Object.values(
            registryConfigurationData.configuracion.moneda
          ).filter((a) => a.tipo === "base")[0].codigo
          : "MXN";
        view.push(
          <Grid item xs={12}>
            <Typography
              color="primary"
              gutterBottom
              variant={"h4"}
              component="h2"
            >
              {data[i].descripcionModalidad}
            </Typography>
            <Typography
              color="primary"
              gutterBottom
              variant={"subtitle1"}
              component="h2"
            >
              {t("modalidadesCategorias.precio", {
                monto: data[i].configModalidad.precio.preventa_1.precio_1,
                moneda: monedaCodigo,
              })}
            </Typography>
            <Typography
              color="primary"
              gutterBottom
              variant={"subtitle1"}
              component="h2"
            >
              Categorías
            </Typography>
          </Grid>
        );
        const ramas = data[i].ramaCat;
        for (var e in ramas) {
          const categorias = ramas[e].categorias;
          let cateogriesView = [];
          for (var f in categorias) {
            if (!categorias[f].hide) {
              cateogriesView.push(
                <Typography
                  key={e + "-" + f + "title"}
                  color="secondary"
                  gutterBottom
                  variant={"subtitle1"}
                  component="h2"
                >
                  {categorias[f].nombreCategoria} -
                  {categorias[f].edadHasta === 200
                    ? " " + categorias[f].edadDesde + " años y mayores"
                    : " " + categorias[f].edadDesde + " a " + categorias[f].edadHasta + " años"}
                </Typography>
              );
            }
          }

          view.push(
            <Grid item xs={12} sm={6} alignItems="center">
              <Typography
                key={e + "modalidad"}
                color="secondary"
                gutterBottom
                variant={"h5"}
                component="h2"
              >
                {ramas[e].rama === "V" ? "Varonil" : "Femenil"}
                {cateogriesView}
              </Typography>
            </Grid>
          );
        }
      }
    }
    return view;
  }



  const view = (
    <Grid
      container
      direction="row"
      wrap="wrap"
      alignItems="center"
      alignContent="center"
      onClick={() => openModal()}
    >
      <Grid item xs={12}>
        <Typography color="primary" gutterBottom variant={"h3"} component="h2">
          {title}
        </Typography>
      </Grid>
      <Grid item xs={12} style={{ padding: "0px" }}>
        {renderType === "image" &&
          eventDetail &&
          eventSubEventsRegistryData && (
            <div>
              <Hidden only={["md", "lg", "xl"]}>
                <img
                  src={
                    imageMobile === undefined || imageMobile === ""
                      ? image
                      : imageMobile
                  }
                  alt="banner"
                  width={"100%"}
                  style={{ cursor: "pointer" }}
                />
              </Hidden>
              <Hidden only={["sm", "xs"]}>
                <img
                  src={image}
                  alt="banner"
                  width={"100%"}
                  style={{ cursor: "pointer" }}
                />
              </Hidden>
            </div>

          )}

        {renderType === "viewFull" &&
          eventDetail &&
          eventSubEventsRegistryData &&
          registryConfigurationData && (
            <Grid
              container
              direction="row"
              wrap="wrap"
              style={{ cursor: "pointer" }}
              onClick={() => openModal()}
            >
              {renderDistanceConfig(eventSubEventsRegistryData)}
            </Grid>
          )}
        {renderType === "viewFullandButton" &&
          eventDetail &&
          eventSubEventsRegistryData &&
          registryConfigurationData && (
            <Grid
              container
              direction="row"
              wrap="wrap"
              style={{ cursor: "pointer" }}
              onClick={() => openModal()}
            >
              {renderDistanceConfig(eventSubEventsRegistryData)}
              <Grid item xs={12}>
                <Button
                  style={{ padding: 30, fontSize: 20, margin: 30 }}
                  variant="contained"
                  color="primary"
                >
                  {t("inscripciones")}
                </Button>
              </Grid>
            </Grid>
          )}
        {renderType === "view" &&
          eventDetail &&
          eventSubEventsRegistryData &&
          registryConfigurationData && (
            <Grid
              container
              direction="row"
              wrap="wrap"
              style={{ cursor: "pointer" }}
              onClick={() => openModal()}
            >
              {renderDistanceConfigResumen(eventSubEventsRegistryData)}
            </Grid>
          )}
        {renderType === "viewandButton" &&
          eventDetail &&
          eventSubEventsRegistryData &&
          registryConfigurationData && (
            <Grid
              container
              direction="row"
              wrap="wrap"
              style={{ cursor: "pointer" }}
              onClick={() => openModal()}
            >
              {renderDistanceConfigResumen(eventSubEventsRegistryData)}
              <Grid item xs={12}>
                <Button
                  style={{ padding: 30, fontSize: 20, margin: 30 }}
                  variant="contained"
                  color="primary"
                >
                  {t("inscripciones")}
                </Button>
              </Grid>
            </Grid>
          )}
        {renderType === "button" &&
          eventDetail &&
          eventSubEventsRegistryData &&
          registryConfigurationData && (
            <Grid
              container
              direction="row"
              wrap="wrap"
              style={{ cursor: "pointer" }}
              onClick={() => openModal()}
            >
              <Grid item xs={12}>
                <Button
                  style={{ padding: 50, fontSize: 30, margin: 50 }}
                  variant="contained"
                  color="primary"
                >
                  {t("inscripciones")}
                </Button>
              </Grid>
            </Grid>
          )}
      </Grid>
      <Grid item xs={12}>
        <Typography color="primary" variant={"h5"} component="h2">
          {textBottom}
        </Typography>
      </Grid>
    </Grid>
  );
  return (
    <div>
      {" "}
      <div style={{ padding: 20 }}>
        {showConfirmation && (
          <SimpleDialogDemo
            fullScreen={false}
            buttonText={"Confirmación de inscripción"}
            openDefault={true}
          >
            <div
              style={{
                padding: 20,
              }}
            >
              <RegistryConfirmationPublic event={event} registry={registry} secure3d={secure3d} />
            </div>
          </SimpleDialogDemo>
        )}
      </div>

      {eventPast && (
        <Typography color="primary" variant={"h2"} component="h2">
          Evento realizado el {formatearFecha(eventDetail.fechaEvento)}
        </Typography>
      )}
      {!eventPast && (
        <SimpleDialogDemo fullScreen={false} view={view}>
          {/* {athleteAccount == null && (
        <Grid
          container
          direction="row"
          wrap="wrap"
          alignItems="center"
          alignContent="center"
          onClick={() => openModal()}
        >
          <Grid
            item
            xs={12}
            alignItems="center"
            style={{ textAlign: "center" }}
          >
            <Typography
              color="primary"
              gutterBottom
              variant={"h5"}
              component="h2"
            >
              Crea tu cuenta de usuario para continuar
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <LoginForm />
          </Grid>
        </Grid>
      )} */}


          <EventRegistryPublicForm eventIdDashport={eventIdDashport} titlesColors={titlesColors} />
          {/* {athleteAccount != null && (
      <EventRegistryPublicForm eventIdDashport={eventIdDashport} />
      )} */}
        </SimpleDialogDemo>)}
    </div>
  );
}
